import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { InputType } from 'enums/InputType';
import { CustomPropertyType, QueryPropertyModel, QueryPropertyType } from 'models/generated/Models.QueryProperty';
import { SelectListItemModel } from 'models/SelectList';
import { TranslatePipe } from 'pipes/translate.pipe';
import { TaskflowTemplateService } from 'services/taskflow-template.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'query-input',
	templateUrl: './query-input.component.html',
	imports: [CustomInputComponent, DateInputComponent, CustomSelectComponent, TranslatePipe]
})
export class QueryInputComponent {

	@Output() valueChange = new EventEmitter<any>();

	inputTypeEnum = InputType;
	queryPropertyType = QueryPropertyType;
	queryCustomType = CustomPropertyType;

	selectList: SelectListItemModel[] = [];
	usersList: SelectListItemModel[] = [];
	taskTemplateTagList: SelectListItemModel[] = [];
	taskflowTemplateTagList: SelectListItemModel[] = [];
	userTeamList: SelectListItemModel[] = [];

	_propertyName = '';

	@Input() value: any;

	@Input()
	set options(options: { [key: string]: string }) {
		this.selectList = [];
		for (let key in options) {
			if (options.hasOwnProperty(key) && key != '$id') {
				this.selectList.push(new SelectListItemModel(key, options[key]));
			}
		}
	}
	
	@Input() queryProperties: QueryPropertyModel[] = [];
	@Input() queryProperty?: QueryPropertyModel;

	@Input()
	set propertyName(name: string) {
		this._propertyName = name;
		this.queryProperty = this.queryProperties!.find(queryProperty => queryProperty.name.toLowerCase() == name.toLowerCase());

		this.usersList = [];
		this.taskTemplateTagList = [];
		this.taskflowTemplateTagList = [];
		this.userTeamList = [];

		if (!this.queryProperty) return;
		
		switch (this.queryProperty!.customProperty) {
		case CustomPropertyType.AssignedToUserTeam:
			this.userService.activeTeams.forEach(team => {
				this.userTeamList.push(new SelectListItemModel(team.id!, team.name));
			});
			break;
		case CustomPropertyType.TaskTemplateTag:
			this.taskflowTemplateService.getAllTaskTemplateTags().then(taskTemplateTags => {
				for (let taskTemplateTag of taskTemplateTags) {
					this.taskTemplateTagList.push(new SelectListItemModel(taskTemplateTag.tag,
						taskTemplateTag.tag));
				}
			});
			break;
		case CustomPropertyType.TaskflowTemplateTag:
			this.taskflowTemplateService.getAllTaskflowTemplateTags().then(taskflowTemplateTags => {
				for (let taskflowTemplateTag of taskflowTemplateTags) {
					this.taskflowTemplateTagList.push(new SelectListItemModel(taskflowTemplateTag.tag,
						taskflowTemplateTag.tag));
				}
			});
			break;
		}

		this.usersList = this.userService.getUserSelectList();
	}
	get propertyName() {
		return this._propertyName;
	}

	constructor(private userService: UserService, readonly taskflowTemplateService: TaskflowTemplateService) {
	}
	
	updateValue(value: any) {
		this.value = value;
		this.valueChange.emit(value);
	}
}
